export const CLOSE_BUTTON_TEST_ID = 'close-button-testId';
export const TOP_BAR_HEIGHT = '48px';
export const MOBILE_TOP_BAR_HEIGHT = '70px';
export const MAIN_SECTION_PADDING = '6px';

export const CONNECTION_STATUS_OFFLINE_BAR_TEXT = "You're offline, check your connection.";
export const CONNECTION_STATUS_ONLINE_BAR_TEXT = 'Connection restored';
export const CONNECTION_STATUS_RECONNECTING_BAR_TEXT = 'Reconnecting...';
export const CONNECTION_STATUS_REDIRECTING_BAR_TEXT = 'Redirecting...';

export const NOTIFICATIONS_TOP_BAR_TEST_ID = 'notifications-top-bar';
export const NOTIFICATIONS_NEW_TOP_BAR_TEST_ID = 'notifications-new-top-bar';

export const COPILOT_TRIGGER_TEST_ID = 'one-trigger';
export const COPILOT_BADGE_TEST_ID = 'one-badge';

import { VISITOR_LIMIT_COOLDOWN_DAYS } from 'constants/limits';

export const CALENDLY_URL_FOR_VISITOR_LIMIT_EXCEEDED =
  'https://calendly.com/text-sales-team/text-expansion-discussion-clone?utm_source=LiveChat+Limits+Discussion&utm_medium=Landing+Page&utm_content=LiveChat&utm_campaign=Monitoring+Limit+Monetization';

export function getVisitorLimitExceededMessagePrefix(limit: number | null): string {
  const limitDisplay = limit !== null ? ` (${limit})` : '';

  return `Visitor limit${limitDisplay}`;
}

export const MESSAGES: readonly string[] = [
  `reached. You can't track or start chats with visitors above the limit.`,
  `reached again. Lost opportunity: Visitors above the limit don't see your campaigns.`,
  `hit for the 3rd time in ${VISITOR_LIMIT_COOLDOWN_DAYS} days. Visits above the limit aren't saved, so you lose customer insights.`,
];

export const VISITOR_LIMIT_TOOLTIP_HEADER = 'Your plan limits how many visitors you can track.';
export const VISITOR_LIMIT_TOOLTIP_INTRO = 'Once you reach the limit,';
export const VISITOR_LIMIT_TOOLTIP_LABEL = 'new visitors:';
export const VISITOR_LIMIT_TOOLTIP_ITEMS = [
  "aren't tracked",
  "don't appear in traffic",
  "don't see campaigns",
  'can still start a chat',
] as const;
